import React from 'react'

export default function BaccaratCard29 () {
  return (
    <div className="center-main-container casino-page">
    <div className="center-container">
      <div className="casino-page-container baccarat29">
        <div className="casino-header">
          <span className="casino-name">
            29Card Baccarat
            <a className="ms-1">
              <small>Rules</small>
            </a>
          </span>
          <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>137250501132243</span>
            </small>
          </span>
        </div>
        <div className="casino-title-header-mobile d-xl-none">
          <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul>
          <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>137250501132243</span>
            </span>
          </div>
        </div>
        <div className="">
          <div className="casino-video">
            <div className="video-box-container">
              <div className="casino-video-box">
                {/* <iframe src="/mediaplayer/teensin/a97c6740-76b4-43f2-b0f9-3ff477cb261b?ip=122.160.119.41" /> */}
              </div>
            </div>
            <div className="casino-video-cards">
              <div className="">
                <h5>Player A</h5>
                <div className="flip-card-container">
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-1">
                <h5>Player B</h5>
                <div className="flip-card-container">
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">9</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">9</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
          </div>
          <div className="casino-detail">
            <div className="casino-table">
              <div className="casino-table-box">
                <div className="casino-table-left-box">
                  <div className="casino-table-header">
                    <div className="casino-nation-detail">Player A</div>
                  </div>
                  <div className="casino-table-body">
                    <div className="casino-table-row">
                      <div className="casino-odds-box">Winner</div>
                      <div className="casino-odds-box">High Card</div>
                      <div className="casino-odds-box">Pair</div>
                      <div className="casino-odds-box">Color Plus</div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.98</span>
                        <span className="casino-nation-book" />
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.98</span>
                        <span className="casino-nation-book" />
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">3.25</span>
                        <span className="casino-nation-book" />
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">2</span>
                        <span className="casino-nation-book" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="casino-table-box-divider" />
                <div className="casino-table-right-box">
                  <div className="casino-table-header">
                    <div className="casino-nation-detail">Player B</div>
                  </div>
                  <div className="casino-table-body">
                    <div className="casino-table-row">
                      <div className="casino-odds-box">Winner</div>
                      <div className="casino-odds-box">High Card</div>
                      <div className="casino-odds-box">Pair</div>
                      <div className="casino-odds-box">Color Plus</div>
                    </div>
                    <div className="casino-table-row">
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.98</span>
                        <span className="casino-nation-book" />
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">1.98</span>
                        <span className="casino-nation-book" />
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">3.25</span>
                        <span className="casino-nation-book" />
                      </div>
                      <div className="casino-odds-box back">
                        <span className="casino-odds">2</span>
                        <span className="casino-nation-book" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="casino-table-full-box mt-3">
                <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/lucky9.png" />
                <div className="casino-odd-box-container">
                  <div className="casino-odds-box back">
                    <span className="casino-odds">4.7</span>
                  </div>
                  <div className="casino-odds-box lay">
                    <span className="casino-odds">5.1</span>
                  </div>
                  <div className="casino-nation-book text-center w-100" />
                </div>
              </div>
            </div>
            <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/teensin">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result result-a">A</span>
              <span className="result result-a">A</span>
              <span className="result result-b">B</span>
              <span className="result result-b">B</span>
              <span className="result result-b">B</span>
              <span className="result result-a">A</span>
              <span className="result result-b">B</span>
              <span className="result result-a">A</span>
              <span className="result result-b">B</span>
              <span className="result result-b">B</span>
            </div>
            <div className="sidebar-box my-bet-container mt-2 d-xl-none">
              <div className="sidebar-title">
                <h4>Rules</h4>
              </div>
              <div className="">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th colSpan={2} className="text-center">
                          Color Plus Rules
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Straight</td>
                        <td>1 TO 2</td>
                      </tr>
                      <tr>
                        <td>Flush</td>
                        <td>1 TO 5</td>
                      </tr>
                      <tr>
                        <td>Trio</td>
                        <td>1 TO 20</td>
                      </tr>
                      <tr>
                        <td>Straight Flush</td>
                        <td>1 TO 30</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-none">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div>
    <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>Rules</h4>
        </div>
        <div className="">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th colSpan={2} className="text-center">
                    Color Plus Rules
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Straight</td>
                  <td>1 TO 2</td>
                </tr>
                <tr>
                  <td>Flush</td>
                  <td>1 TO 5</td>
                </tr>
                <tr>
                  <td>Trio</td>
                  <td>1 TO 20</td>
                </tr>
                <tr>
                  <td>Straight Flush</td>
                  <td>1 TO 30</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  )
}
